import { customTv } from "#utils";

export const boxStyles = customTv({
  base: "w-4 h-4 shrink-0 rounded-[.125rem] flex items-center justify-center border transition",
  variants: {
    uiVersion: {
      v1: "",
      v2: "",
    },
    isSelected: {
      false: "",
      true: "",
    },
    isInvalid: {
      true: "",
    },
    isDisabled: {
      true: "",
    },
    isHovered: {
      true: "",
    },
    isFocused: {
      true: "",
    },
  },
  compoundVariants: [
    // V2 styling (existing behavior)

    // Unselected
    {
      uiVersion: "v2",
      isSelected: false,
      class: "bg-background-primary border-outline-input-enabled focus:border-outline-input-focus",
    },
    {
      uiVersion: "v2",
      isSelected: false,
      isHovered: true,
      class: "border-outline-input-hover",
    },

    // Selected
    {
      uiVersion: "v2",
      isSelected: false,
      isFocused: true,
      class: "border-outline-input-focus",
    },
    {
      uiVersion: "v2",
      isSelected: true,
      class:
        "bg-brand-primary border-brand-primary focus:bg-interactive-primary-button-focus-background",
    },
    {
      uiVersion: "v2",
      isSelected: true,
      isHovered: true,
      class:
        "bg-interactive-primary-button-hover-background border-interactive-primary-button-hover-background",
    },
    {
      uiVersion: "v2",
      isSelected: true,
      isFocused: true,
      class:
        "bg-interactive-primary-button-focus-background border-interactive-primary-button-focus-background",
    },

    // Invalid
    {
      uiVersion: "v2",
      isInvalid: true,
      class: "text-text-negative border-text-negative",
    },
    {
      uiVersion: "v2",
      isInvalid: true,
      isHovered: true,
      class: "border-outline-input-hover",
    },
    {
      uiVersion: "v2",
      isInvalid: true,
      isFocused: true,
      class: "border-outline-input-focus",
    },
    {
      uiVersion: "v2",
      isInvalid: true,
      isSelected: true,
      class: "bg-text-negative",
    },
    {
      uiVersion: "v2",
      isInvalid: true,
      isSelected: true,
      isHovered: true,
      class:
        "bg-interactive-primary-button-hover-background border-interactive-primary-button-hover-background",
    },
    {
      uiVersion: "v2",
      isInvalid: true,
      isSelected: true,
      isFocused: true,
      class:
        "bg-interactive-primary-button-focus-background border-interactive-primary-button-focus-background",
    },

    // Disabled
    {
      uiVersion: "v2",
      isDisabled: true,
      class: "border-interactive-disabled-outline",
    },
    {
      uiVersion: "v2",
      isDisabled: true,
      isSelected: true,
      class:
        "bg-interactive-secondary-button-focus-background border-interactive-secondary-button-focus-background",
    },

    // V1 MUI-like styling
    {
      uiVersion: "v1",
      isSelected: false,
      class: "bg-neutral-white border-gray-400 hover:border-gray-300",
    },
    {
      uiVersion: "v1",
      isSelected: true,
      class: "bg-[rgb(13,17,22)] border-transparent hover:opacity-90",
    },
    {
      uiVersion: "v1",
      isInvalid: true,
      class: "text-text-negative",
    },
    {
      uiVersion: "v1",
      isDisabled: true,
      class: "border-gray-600 opacity-50",
    },
    {
      uiVersion: "v1",
      isSelected: true,
      isDisabled: true,
      class: "bg-[rgb(13,17,22)] border-gray-600 opacity-50 hover:opacity-50",
    },
  ],
});
